export enum userFormTypes {
  GET_USER_FORM_DATA = 'GET_USER_FORM_DATA',
  GET_USER_FORM_ERROR = 'GET_USER_FORM_ERROR',
  USER_FORM_LOADING = 'USER_FORM_LOADING',
  USER_FORM_LOADING_SUBMIT = 'USER_FORM_LOADING_SUBMIT',
  USER_FORM_UPDATE_SUBMIT = 'USER_FORM_UPDATE_SUBMIT',
  USER_FORM_UPDATE_TRACK_ID = 'USER_FORM_UPDATE_TRACK_ID',
  USER_FORM_UPDATE_REFERRAL_METADATA_AND_OBJECT = 'USER_FORM_UPDATE_REFERRAL_METADATA_AND_OBJECT',
  SET_FORM_FIELD_ERRORS = 'SET_FORM_FIELD_ERRORS',
  CLEAR_FORM_FIELD_ERRORS = 'CLEAR_FORM_FIELD_ERRORS',
  SET_OBJECTS_FROM_URL = 'SET_OBJECTS_FROM_URL',
  CHANGE_DEFAULT_OPTIONS = 'CHANGE_DEFAULT_OPTIONS',
  CHANGE_DEFAULT_VALUE = 'CHANGE_DEFAULT_VALUE',
  GET_FIELDS_CATEGORIES = 'GET_FIELDS_CATEGORIES',
  SET_AZURE_SOLUTIONS = 'SET_AZURE_SOLUTIONS',
  SET_PARTNER_CENTRAL_USERS = 'SET_PARTNER_CENTRAL_USERS',
}
